import request from '@/utils/request'

const customsDeclarationContractApi = {
  trade_asset_appraisal_mandate_agreement_list: '/trade/asset_appraisal_mandate_agreement/',
  trade_asset_appraisal_mandate_agreement_create: '/trade/asset_appraisal_mandate_agreement/',
  trade_asset_appraisal_mandate_agreement_update: '/trade/asset_appraisal_mandate_agreement/',
  trade_asset_appraisal_mandate_agreement_delete: '/trade/asset_appraisal_mandate_agreement/',
  trade_asset_appraisal_mandate_agreement_archived: '/trade/asset_appraisal_mandate_agreement_archived/',
  trade_asset_appraisal_mandate_agreement_attachment: '/trade/asset_appraisal_mandate_agreement_attachment/'
}

/**
 * 列表
 */
export function asset_appraisal_mandate_agreement_list (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function asset_appraisal_mandate_agreement_create (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function asset_appraisal_mandate_agreement_update (parameter, asset_appraisal_mandate_agreement_id) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_update + asset_appraisal_mandate_agreement_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function asset_appraisal_mandate_agreement_delete (asset_appraisal_mandate_agreement_id) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_delete + asset_appraisal_mandate_agreement_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function asset_appraisal_mandate_agreement_archived (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
* 担保合同附件列表
* @param parameter
* @returns {AxiosPromise}
*/
export function asset_appraisal_mandate_agreement_attachment_list (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 担保合同附件添加
 */
export function asset_appraisal_mandate_agreement_attachment_create (parameter) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件删除
 */
export function asset_appraisal_mandate_agreement_attachment_delete (contract_attachment_id) {
  return request({
    url: customsDeclarationContractApi.trade_asset_appraisal_mandate_agreement_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
